module.exports = __webpack_public_path__ + "static/our-advantage-1.3fcb59e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/our-advantage-1.jpg
// module id = 518
// module chunks = 40238393429361